const mediaItems = [
  {
    title: '某顶流明星深夜密会：独家视频完整版流出',
    duration: '08:32',
    views: '128.6万',
    tag: '娱乐圈',
    img: 'https://readdy.ai/api/search-image?query=Dark%20mysterious%20night%20scene%20with%20warm%20streetlamp%20glow%2C%20cinematic%20noir%20atmosphere%2C%20dramatic%20shadows%2C%20premium%20editorial%20photography%2C%20amber%20and%20crimson%20tones%2C%20abstract%20urban%20night%20composition%2C%20no%20text%2C%20no%20people&width=640&height=400&seq=media-01&orientation=landscape',
  },
  {
    title: '餐饮后厨卫生黑幕：记者暗访实拍第一视角',
    duration: '12:15',
    views: '96.3万',
    tag: '食品安全',
    img: 'https://readdy.ai/api/search-image?query=Dimly%20lit%20kitchen%20interior%20with%20dramatic%20contrast%2C%20warm%20moody%20lighting%2C%20investigative%20journalism%20aesthetic%2C%20premium%20editorial%20photography%2C%20amber%20and%20deep%20shadow%20tones%2C%20abstract%20composition%2C%20no%20text%2C%20no%20people&width=640&height=400&seq=media-02&orientation=landscape',
  },
  {
    title: '网红直播间争吵录音：百万合约背后的博弈',
    duration: '05:47',
    views: '85.2万',
    tag: '直播圈',
    img: 'https://readdy.ai/api/search-image?query=Modern%20livestream%20studio%20with%20dramatic%20stage%20lighting%2C%20warm%20spotlight%20and%20deep%20shadows%2C%20cinematic%20atmosphere%2C%20premium%20editorial%20photography%2C%20amber%20and%20crimson%20accents%2C%20no%20text%2C%20no%20people&width=640&height=400&seq=media-03&orientation=landscape',
  },
  {
    title: '某大型企业高管会议录音：内部权力斗争揭秘',
    duration: '15:20',
    views: '73.8万',
    tag: '社会热点',
    img: 'https://readdy.ai/api/search-image?query=Corporate%20boardroom%20with%20dramatic%20cinematic%20lighting%2C%20dark%20moody%20atmosphere%2C%20warm%20amber%20glow%2C%20premium%20editorial%20photography%2C%20deep%20shadows%20and%20contrast%2C%20no%20text%2C%20no%20people&width=640&height=400&seq=media-04&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-900 mb-3">精选视频</h2>
          <p className="text-foreground-500 text-sm max-w-xl mx-auto">热门黑料视频在线观看，精彩内容不容错过</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 max-w-6xl mx-auto">
          {mediaItems.map((item, i) => (
            <article
              key={i}
              className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200/60 transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full aspect-[16/10] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/10 transition-colors" />
                <div className="absolute bottom-3 right-3 px-2 py-1 bg-black/70 text-white text-xs font-medium rounded-md">
                  {item.duration}
                </div>
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-0.5 bg-accent-500/90 text-white text-xs rounded-md">{item.tag}</span>
                </div>
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                  <div className="w-12 h-12 rounded-full bg-primary-500/90 flex items-center justify-center">
                    <i className="ri-play-fill text-white text-xl ml-0.5" />
                  </div>
                </div>
              </div>
              <div className="p-3.5">
                <h3 className="text-sm font-bold text-foreground-800 group-hover:text-primary-500 transition-colors line-clamp-2 mb-2">
                  {item.title}
                </h3>
                <div className="flex items-center gap-3 text-foreground-400">
                  <span className="flex items-center gap-1 text-xs">
                    <i className="ri-eye-line" />
                    {item.views}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}